/**
 * Codemade OÜ
 *
 * Default Application state
 *
 * @summary Default Application state
 * @author Borka Martin Orlov
 *
 * Created at     : 2020-08-23 00:02:57
 * Last modified  : 2020-08-23 00:02:57
 */

export default {
    user: {

        // Axios uses this to intercept requests and insert token.
        // Used to cancel it after logout
        token_interceptor: {},

        // OAUTH2 Access token
        token: null,

        // USER model data
        account: {},

        // PROFILE model data
        profile: {},

        // Easy boolean to check if you're logged in
        isLoggedIn: false,
    }, 
};
